export default "__VITE_ASSET__D2iEBQJW__"